<template>
  <section class="section" style="padding-top:50px;padding-bottom:50px;">
    <div class="content" style="font-size: 2em; margin: 0 auto; min-height: 600px;">
      <div v-if="signatures.length > 0" class="main-text" style="margin-top: 30px;">Minhas Assinaturas</div>
      <div v-if="signatures.length > 0" class="content" style="margin-top: 20px;">
        <div class="list_plans" v-for="item in signatures" :key="item.id">
          <div class="show_plan">
            <div class="card_event">
              <div class="show-name">{{ item.name }}</div>
              <div class="show-date">{{ item.desc }}</div>
              <div class="show-date">R$ {{ item.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
            </div>
            <div class="btn-buy">Assinatura Atual</div>
          </div>
          <div class="finish_plan">
            <div v-if="!item.active && item.valid === 0" class="show-name" style="color:red;padding-top:30px;">
              Aguardando Pagamento
              <button @click="callPayment(item)" class="button-save" style="margin-top:60px;font-size:14px;"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
              <!-- @click="callPix(item)" -->
              <div v-if="error" class="hint">{{ error[0] }}</div>
            </div>
            <div v-if="!item.active && item.valid === 1" class="show-name" style="color:red;padding-top:30px;">
              Assinatura Vencida
              <div class="show-name" style="margin-top:10px;">Vencimento</div>
              <div class="show-date">{{ item.nextDate }}</div>
              <button v-if="item.valid === 1" @click="callPayment(item)" class="button-save" style="margin-top:20px;font-size:14px;"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
              <div v-if="item.valid === 1 && error" class="hint">{{ error[0] }}</div>
            </div>
            <div v-if="item.active" class="show-name" style="color:#33cc33;padding-top:30px;">
              Sua assinatura está Ativa
              <div class="show-name" style="margin-top:10px;">Vencimento</div>
              <div class="show-date">{{ item.nextDate }}</div>
              <button v-if="item.valid === 1" @click="callPayment(item)" class="button-save" style="margin-top:50px;font-size:14px;"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
              <div v-if="item.valid === 1 && error" class="hint">{{ error[0] }}</div>
            </div>
            <div class="content">
              <div style="color:black;margin-top:15px;font-size:12px;">Para informações, ser incluído no grupo privado, pagamentos, alteração de assinatura, entre em contato abaixo</div>
              <img style="margin-top:5px; height: 50px; cursor: pointer;" src="/img/telegram.png" @click="gotoTelegram()" alt="Swiss Money" title="Swiss Money">
            </div>
          </div>
        </div>
      </div>
      <div v-if="product" class="main-text" style="margin-top: 30px;">Assinatura Escolhida</div>
      <div v-if="product" class="content" style="margin-top: 20px;">
        <div class="list_plans">
          <div class="show_plan">
            <div class="card_event">
              <div class="show-name">{{ product.name }}</div>
              <div class="show-date">{{ product.desc }}</div>
              <div v-if="product.discount && product.type === 'percent'" class="plan_discount">R$ {{ (product.price + (product.discount * product.price / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div v-if="product.discount && product.type === 'fixed'" class="plan_discount">R$ {{ (product.price + product.discount).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>

              <!--<div v-if="product.discount" class="plan_discount">R$ {{ (product.price + (product.discount * product.price / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>-->
              <div class="show-date">R$ {{ product.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div v-if="product.expiration" class="show-date">Válido até {{ product.expiration }}</div>
            </div>
          </div>
          <div class="finish_plan">
            <div class="show-name">
              Assim que o pagamento for finalizado, sua assinatura é ativada automaticamente.
            </div>
            <!-- <div class="actions btn-buyplan" @click="finishPlan"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i>SOLICITAR ASSINATURA</div> -->
            <div class="actions">
              <button @click="callPayment(null)" style="font-size:14px;" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Realizar Pagamento</span></button>
              <div v-if="error" class="hint">{{ error[0] }}</div>
              <button @click="product = null" class="button-save" style="font-size: 16px;margin-top: 60px;background-image: linear-gradient(to bottom right, #3d8a46, #3d8a46);"><i class="fas fa-check'"></i><span>Escolher outra assinatura</span></button>
              <!-- <div id="wallet_container"></div>
              <div id="paymentBrick_container"></div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="signatures.length > 0" class="main-text" style="margin-top: 30px;">Minha assinatura</div>
      <div v-if="signatures.length > 0" class="content" style="margin-top: 20px;">
        <div class="list_plans">
          <div v-for="item in signatures" :key="item.id">
            <div class="show_plan">
              <div class="card_event">
                <div class="show-name">{{ item.name }}</div>
                <div class="show-date">{{ item.desc }}</div>
                <div class="show-date">R$ {{ item.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              </div>
            </div>
            <div class="finish_plan">
              <div class="card_event">
                <div class="show-name">{{ item.name }}</div>
                <div class="show-date">{{ item.desc }}</div>
                <div class="show-date">R$ {{ item.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="main-text" style="margin-top: 30px;">Assinaturas mensais do Swiss Money</div>
      <div class="content" style="margin-top: 20px;">
        <div class="list_plans">
          <div v-for="item in products" :key="item.id">
            <div v-if="item.active">
              <div class="show_plan" @click="selectProduct(item)">
                <div class="card_event">
                  <div class="show-name">{{ item.name }}</div>
                  <div class="show-date">{{ item.desc }}</div>
                  <div v-if="item.discount && item.type === 'percent'" class="plan_discount">R$ {{ (item.price + (item.discount * item.price / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
                  <div v-if="item.discount && item.type === 'fixed'" class="plan_discount">R$ {{ (item.price + item.discount).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>

                  <!-- <div v-if="item.discount" class="plan_discount">R$ {{ (item.price + (item.discount * item.price / 100)).toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div> -->
                  <div class="show-date">R$ {{ item.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
                  <div v-if="item.expiration" class="show-date">Válido até {{ item.expiration }}</div>
                </div>
                <div class="btn-buy">ASSINAR</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <UserPix v-if="selectedWaiting" :ticket="selectedWaiting" :closeModal="function () { selectedWaiting = null }"/> -->
    <Payment v-if="selectedWaiting" :product="product" :signId="signId ? signId : null" :closeModal="function () {
      selectedWaiting = null
      product = null
      signId = null
      getData()
    }"/>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getAll } from '../../admin/api/product'
import { create, payment, get } from '../api/signature'
import Payment from './Payment.vue'

export default {
  name: 'assinatura',
  components: { Payment },
  props: ['type'],
  data () {
    return {
      error: [],
      loading: false,
      product: null,
      selectedWaiting: null,
      products: [],
      signatures: [],
      signId: null
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async mounted () {
    if (!this.user) {
      this.$router.push('/')
      this.$store.commit('redirect', '/usuario')
      this.$store.commit('showLogin', true)
      return false
    }
    this.getData()
    document.body.style.backgroundColor = '#f2f2f2'
  },
  methods: {
    selectProduct (item) {
      if (this.signatures.length > 0) {
        this.product = null
        //this.$message.error('Você já possui uma assinatura', { duration: 3000 })
        this.$dialog.confirm('Deseja adquirir também essa assinatura?', {
          loader: true, // default: false - when set to true, the proceed button shows a loader when clicked.
          // And a dialog object will be passed to the then() callback
          okText: 'Continuar',
          cancelText: 'Cancelar'
        }).then(async dialog => {
          this.product = item
          window.scrollTo(0, 0)
          dialog.close()
        }).catch(() => {
          // Triggered when cancel button is clicked
          // console.log('Delete aborted')
          dialog.close()
        })
      } else {
        this.product = item
        window.scrollTo(0, 0)
      }
    },
    gotoTelegram () {
      window.open('https://t.me/SuporteSwissMoney', '_blank')
    },
    async getData () {
      try {
        this.products = await getAll()
        this.signatures = await get()
      } catch (error) {
        logger.error(error, this)
      }
    },
    async callPayment (item) {
      // console.log('oi')
      this.selectedWaiting = true
      if (item) {
        this.signId = item.id
        this.product = {
          name: item.name,
          id: item.product,
          price: item.price
        }
      } else {
        this.signId = null
      }

    },
    async callPix (item) {
      // Parameters and options
      /* let message = 'Deseja gerar um PIX para pagar essa assinatura?'
      let options = {
        html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
        loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
        reverse: false, // switch the button positions (left to right, and vise versa)
        okText: 'Continuar',
        cancelText: 'Cancelar',
        animation: 'zoom', // Available: "zoom", "bounce", "fade"
        type: 'basic', // coming soon: 'soft', 'hard', basic
        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
        clicksCount: 0, // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
        backdropClose: false, // set to true to close the dialog when clicking outside of the dialog window, i.e. click landing on the mask
        customClass: '' // Custom class to be injected into the parent node for the current dialog instance
      } */

      this.$dialog.confirm('Deseja gerar um PIX para pagar essa assinatura?', {
        loader: true, // default: false - when set to true, the proceed button shows a loader when clicked.
        // And a dialog object will be passed to the then() callback
        okText: 'Continuar',
        cancelText: 'Cancelar'
      }).then(async dialog => {
        // Triggered when proceed button is clicked
        // dialog.loading(false) // stops the proceed button's loader
        // dialog.loading(true) // starts the proceed button's loader again
        // dialog.close() // stops the loader and close the dialog
        // do some stuff like ajax request.
        // console.log('Delete action completed ')
        try {
          // if (this.loading) return false
          this.loading = true
          this.error = []
          if (item) {
            this.product = {
              name: item.name,
              id: item.product,
              price: item.price
            }
            this.signId = item.id
          } else {
            this.signId = null
          }
          const resultPix = await payment(this.signId, this.product.name, this.product.id, this.product.price)
          dialog.close()
          this.selectedWaiting = {
            printUrl: resultPix
          }
          this.product = null
          this.signatures = await get()
          this.$analytics.event('bought', this.product.id)
          this.loading = false
        } catch (error) {
          dialog.close()
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = data.fields
          } else if (data.error) {
            this.error = [data.error]
          } else {
            logger.error(error, this)
          }
          this.loading = false
        }
      }).catch(() => {
        // Triggered when cancel button is clicked
        // console.log('Delete aborted')
      })
      // Trigger a confirmation dialog
      /* this.$dialog.confirm(message, options)
      .then(async function () {
        // This will be triggered when user clicks on proceed
        console.log('ok')
        try {
          // if (this.loading) return false
          this.loading = true
          this.error = []
          if (item) {
            this.product = {
              name: item.name,
              id: item.product,
              price: item.price
            }
          }
          const resultPix = await payment(this.product.name, this.product.id, this.product.price)
          this.selectedWaiting = {
            printUrl: resultPix
          }
          this.product = null
          this.signatures = await get()
          this.$analytics.event('bought', this.product.id)
          this.loading = false
        } catch (error) {
          const data = error.response ? error.response.data : {}
          // Validation error
          if (data.error === 'Validation error') {
            this.error = data.fields
          } else if (data.error) {
            this.error = [data.error]
          } else {
            logger.error(error, this)
          }
          this.loading = false
        }
      })
      .catch(function () {
        // This will be triggered when user clicks on cancel
        // console.log('nok')
      }) */

      /* if (confirm('Deseja gerar um PIX para pagar essa assinatura?')) {
      } */
    },
    async finishPlan () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        await create(this.product.id, this.product.price)
        this.product = null
        this.getData()
        this.loading = false
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import "../_asset/scss/_variables";
.dg-content {
  text-align: center;
}
.dg-btn--cancel {
  background-color: $primary-color !important;
}
.dg-btn--ok {
  border-color: $primary-color;
  color: $primary-color;
}

.dg-btn-loader .dg-circle {
  background-color: $primary-color;
}
.hint {
    font-size: 12px;
    color: $error-color;
    margin-top: 3px;
  }
.button-save {
  margin-top: 20px;
    color: #fff;
    border: none;
    border-radius: 100px;
    box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.4);
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    font-size: 1em;
    font-weight: 400;
    width: auto;
    height: 40px;
    padding: 0 15px;
    cursor: pointer;
    &:focus {
      outline: 0;
    }
    i {
      margin-right: 7px;
    }
  }

.section {
  margin-top: $menu-height;
  margin: 0px;
  padding: 0px;
}
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
.finish_plan {
  text-align: center;
  width: 400px;
  height: 300px;
  margin: 5px;
  margin-left: 20px;
  //border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  .btn-buyplan {
    text-align: center;
    font-size: 0.7em;
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    border-radius: 5px 5px;
    object-fit: cover;
    width: 400px;
    flex: none;
    margin-top: 40px;
  }
}
.show_plan {
  text-align: center;
  width: 200px;
  height: 300px;
  margin: 5px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 1px 3px 1px rgba(0, 0, 0, 0.2);
    transform: scale(1.02);
  }
  .btn-buy {
    text-align: center;
    font-size: 0.7em;
    color: #fff;
    background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    border-radius: 0 0 5px 5px;
    object-fit: cover;
    width: 200px;
    flex: none;
  }
}
.card_event {
  min-height: 155px;
  flex: 1;
}
.show-name {
  color: #202020;
  font-size: 20px;
}
.show-date {
  font-size: 14px;
  font-weight: 300;
  color: #202020;
  margin: 2px 10px;
  padding: 0px 10px;
}
.plan_discount {
  text-decoration: line-through;
  font-size: 14px;
  color: #e92a2a;
}
.list_plans {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  align-content: stretch;
}
.main-text {
  margin-top: 60px;
  padding: 20px;
  color: #202020;
  font-size: 30px;
  text-align: center;
  font-family:'Arial';
  width: 95%;
}
</style>
